
import './App.css';
import Home from './home';
function App() {
  return (
    <Home></Home>
  );
}

export default App;
